module.exports = "<div ui-view=main id=mainview></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/schedule/schedule.html
// module id = 467
// module chunks = 0